import { initMain } from "./vue/controllers/main";
import { header } from "./vue/controllers/header";
import lazyload from "./features/lazy-load";

lazyload();
initMain([], {
  TrendsHorizontal: () =>
    import("./vue/components/trends/TrendsHorizontal.vue"),
  PresidentialElec2026ColGraph: () =>
    import(
      "./vue/components/presidential-elec2026-colgraph/PresidentialElec2026ColGraph.vue"
    ),
});
header();
